import { Outlet } from 'react-router-dom';
import SurgeonRoute from '../components/routes/SurgeonRoute';

const SurgeonLayout = () => {
  return (
    <SurgeonRoute>
      <main className="">
        <Outlet />
      </main>
    </SurgeonRoute>
  );
};

export default SurgeonLayout;
